import styled, { css } from "styled-components";
import { theme } from "../../../../../../../common-deprecated/styles/v2/lexus/theme/lexusTheme";

export const DropDown = styled.div`
    padding: ${theme.space[3]}px 0 0;
`;

export const DropDownTitle = styled.div`
    font-family: ${theme.fonts.regular};
    font-size: 1.8rem;
    letter-spacing: 1%;
    line-height: 2.4rem;
    text-transform: uppercase;
    color: ${theme.colors.midnight};
`;

export const Wrapper = styled.div<{ isOpen?: boolean }>`
    padding: ${theme.space[2]}px 0;
    border-bottom: 1px solid ${theme.colors.silver};

    ${({ isOpen }) =>
        isOpen &&
        css`
            padding-bottom: 0;
            ${DropDown} {
                margin-bottom: ${theme.space[1]}px;
            }
        `};
    .icon::before {
        position: relative;
        top: 4px;
    }
`;

export const Header = styled.div`
    display: flex;
    justify-content: space-between;
    cursor: pointer;
`;
